export default __webpack_public_path__ + "static/media/Hoshen Ishay CV.59731175.pdf";